import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from '../hooks/use-toast';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const LoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ identifier: '', password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.identifier || !form.password) {
      toast({ title: "All fields are required", variant: "destructive" });
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${API}/api/auth/login`, {
        identifier: form.identifier,
        password: form.password,
      });

      // Store session
      localStorage.setItem('auth_token', res.data.access_token);
      localStorage.setItem('auth_name', res.data.user.name);
      localStorage.setItem('auth_email', res.data.user.email);
      localStorage.setItem('auth_username', res.data.user.username);

      toast({ title: "Login successful!", description: `Welcome back, ${res.data.user.name}` });
      navigate('/');
    } catch (error) {
      toast({ title: "Login failed", description: error.response?.data?.detail || "Incorrect username or password", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-900" data-testid="login-title">Welcome Back</h1>
            <p className="text-gray-500 mt-1">Log in to JIT Cargo Express</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label>Username or Email *</Label>
              <Input data-testid="login-identifier" value={form.identifier} onChange={(e) => setForm(prev => ({ ...prev, identifier: e.target.value }))} placeholder="Username or email" className="mt-1" />
            </div>
            <div>
              <Label>Password *</Label>
              <Input data-testid="login-password" type="password" value={form.password} onChange={(e) => setForm(prev => ({ ...prev, password: e.target.value }))} placeholder="Your password" className="mt-1" />
            </div>

            <div className="text-right">
              <Link to="/forgot-password" className="text-sm text-[#D62828] hover:underline" data-testid="forgot-password-link">Forgot Password?</Link>
            </div>

            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-[#D62828] hover:bg-[#B01F1F] text-white font-bold py-3">
              {loading ? 'Logging in...' : 'Log In'}
            </Button>
          </form>

          <p className="text-center text-sm text-gray-500 mt-6">
            Don't have an account?{' '}
            <Link to="/signup" className="text-[#D62828] font-semibold hover:underline" data-testid="goto-signup">Sign up</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
